import React from 'react'

export default ({ children, ...rest }) => (
  <div className="container" {...rest}>
    {children}
  </div>
)
